// components/assigned-tasks/AssignedTasksPrjSection.jsx
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DaysLeft from "../modules/days-left/days-left.component";
import Priority from "../modules/priority/priority.component";
import { DEFAULT_PRIORITY_VALUE } from "../../utils/priorities";
import { createNewTaskMobile } from "../../firebase/firebase.utils";

import "./assigned-tasks.styles.scss";

import { db, updateTaskAsDone } from "../../firebase/firebase.utils";

import { FiSquare, FiCheckSquare } from "react-icons/fi";
import { BsPlus } from "react-icons/bs";

const AssignedTasksPrjSection = ({
  spaceId,
  color,
  name,
  assignedColTasks,
  project,
  expandAll,
}) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (expandAll !== null) {
      setIsOpen(expandAll);
    }
  }, [expandAll]);

  const projectTasks =
    assignedColTasks?.filter((task) => task.fromStationId === project.id) || [];

  const handleCheck = (task, done) => {
    document.getElementById("done_tone").play();
    // const IdRef = currentUser.uid;
    if (task.done) {
      updateTaskAsDone(task.fromSpaceId, task.fromStationId, task.id, false);
    } else {
      updateTaskAsDone(task.fromSpaceId, task.fromStationId, task.id, true);
      console.log("it says it is not done!");
    }
  };

  const handleEventClick = (task, event) => {
    const rect = event.currentTarget
      .closest(".personalItem_Item")
      .getBoundingClientRect();

    navigate(`task/${task.id}`, {
      state: {
        taskOrigin: {
          x: rect.left,
          y: rect.top,
          width: rect.width,
          height: rect.height,
        },
      },
    });
  };

  // FROM MOBILE
  const handleAddPrjTask = async (station, title) => {
    const trimmed = title.trim();
    if (!trimmed || !currentUser?.uid) return;

    const phaseId = station.phaseOrder?.[0] || null;

    const taskObj = {
      title: trimmed,
      description: null,
      doneStatus: false,
      startdate: null,
      enddate: null,
      duration: "00:30",
      allDay: "false",
      createdBy: currentUser.uid,
      fromSpaceId: station.fromSpaceId,
      fromStationId: station.stationId,
      phase: phaseId,
      assign: currentUser.uid,
      priority: DEFAULT_PRIORITY_VALUE,
      progress: 0,
      rrule: null,
      type: "task",
    };

    setTitle("");
    await createNewTaskMobile(currentUser.uid, taskObj);
  };

  return (
    <div className={`personalItem_Details ${isOpen ? "open" : ""}`}>
      <button
        type="button"
        className="personalItem_Summary"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div
          className="personalItem_Header"
          style={{ borderLeft: `2px solid ${color}` }}
        >
          <h4 className="personalItem_HeaderIcon">{project.emojicon}</h4>
          <h4 className="personalItem_HeaderText">{project.name}</h4>
        </div>
      </button>
      <div className="detailsContent">
        <div className="detailsContent_Inner">
          {projectTasks.map((task) => {
            const { fromSpaceId, fromStationId } = task;
            return (
              <div
                key={task.id}
                className="fc-event personalItem_Item"
                id={task.id}
                title={task.title}
                start={task.startdate}
                end={task.enddate}
                duration={task.duration}
                fromSpaceId={task.fromSpaceId}
                fromStationId={task.fromStationId}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      columnGap: "5px",
                      cursor: "grab",
                      paddingTop: "6px",
                      paddingBottom: "6px",
                    }}
                  >
                    <div className="at__check-and-name">
                      <div
                        onClick={(id, done) => handleCheck(task, done)}
                        className="at__checkBox"
                      >
                        {task.done ? <FiCheckSquare /> : <FiSquare />}
                      </div>
                      <audio
                        id="done_tone"
                        src="/media/mixkit-cool-interface-click-tone-2568.wav"
                      ></audio>
                      <div
                        className="at__content"
                        onClick={(event) => handleEventClick(task, event)}
                      >
                        <p>{task.title}</p>
                      </div>
                    </div>
                    <div className="at__modules">
                      <div className="at__daysLeft">
                        <DaysLeft task={task} />
                      </div>
                      <div className="at__priority">
                        <Priority task={task} />
                      </div>
                      {/* <div className="at__by">
                          <CreatedBy task={task} />
                        </div> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          {projectTasks.length < 1 && (
            <div className="personalItem_NoItem">
              <p>No tasks to show</p>
            </div>
          )}
          <form
            className="addQuickBtn"
            onSubmit={(e) => {
              e.preventDefault();
              handleAddPrjTask(project, title);
            }}
          >
            <BsPlus />
            <input
              type="text"
              value={title}
              placeholder={`Add task to ${project.name}`}
              onChange={(e) => setTitle(e.target.value)}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default AssignedTasksPrjSection;
